// Minimal rich-text sanitizer for conversation messages. Allows only the
// formatting our composer produces (bold/italic/underline, colour, size) and
// strips everything else — scripts, handlers, links, iframes — so stored HTML
// can never execute in the app or on the public tracking page.
const ALLOWED_TAGS = new Set(['B', 'STRONG', 'I', 'EM', 'U', 'BR', 'DIV', 'P', 'SPAN', 'FONT']);

export const sanitizeHtml = (html) => {
    if (!html) return '';
    const doc = new DOMParser().parseFromString(String(html), 'text/html');
    const clean = (node) => {
        [...node.children].forEach(el => {
            clean(el);
            if (!ALLOWED_TAGS.has(el.tagName)) {
                el.replaceWith(...el.childNodes);
                return;
            }
            [...el.attributes].forEach(a => {
                const n = a.name.toLowerCase();
                if (el.tagName === 'FONT' && (n === 'color' || n === 'size')) return;
                if (n === 'style') {
                    const kept = (a.value.match(/(?:^|;)\s*(color|font-size)\s*:\s*[^;]+/gi) || []).join(';');
                    if (kept) { el.setAttribute('style', kept); return; }
                }
                el.removeAttribute(a.name);
            });
        });
    };
    clean(doc.body);
    return doc.body.innerHTML;
};

export const htmlToText = (html) => {
    if (!html) return '';
    const doc = new DOMParser().parseFromString(String(html), 'text/html');
    return (doc.body.textContent || '').trim();
};

// True when the HTML carries real formatting beyond plain text.
export const hasFormatting = (html) => /<(b|strong|i|em|u|font|span)[\s>]/i.test(String(html || ''));
